import {Box} from '@mui/material';
import ArrReviewMetrics from '../../../components/common/arr-review-metrics/ArrReviewMetrics';

const MetricsDemo: React.FC = () => {
  return (
    <Box>
      <Box sx={{backgroundColor: '#182231', padding: '16px'}}>
        <ArrReviewMetrics type="Issue Coding" />
      </Box>
      <Box sx={{backgroundColor: '#182231', padding: '16px'}}>
        <ArrReviewMetrics type="Relevancy" />
      </Box>
    </Box>
  );
};
export default MetricsDemo;
